import { REQUISITOS_SENHA } from "../utils/senha";

// Requisitos da senha, marcando os que a senha digitada já cumpre (o estilo vem de quem usa)
export function RequisitosSenha({ senha, className }) {
  return (
    <ul className={className} aria-label="Requisitos da senha">
      {REQUISITOS_SENHA.map(([texto, ok]) => {
        const cumpre = ok(senha || "");
        return <li key={texto} className={cumpre ? "is-met" : ""}><span aria-hidden="true">{cumpre ? "✓" : "○"}</span>{texto}</li>;
      })}
    </ul>
  );
}
